export default __webpack_public_path__ + "static/media/section-bg-search-slide3.e814e5bc.jpg";